const buttonBase = {};

export default buttonBase;
